import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, MessageCircle, X, Mail, Clock } from "lucide-react";
import { CONTACT } from "@/lib/data";

export default function FloatingContact() {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.96 }}
            transition={{ duration: 0.25 }}
            className="w-[320px] bg-[color:var(--cream)] border border-black/15 shadow-2xl p-6"
            data-testid="floating-contact-card"
          >
            <div className="flex items-start justify-between mb-4">
              <div>
                <div className="text-[10px] tracking-[0.24em] uppercase text-[color:var(--burgundy)]">Wir sind für Sie da</div>
                <div className="font-serif text-xl mt-1">Kontakt</div>
              </div>
              <button onClick={() => setOpen(false)} data-testid="floating-close" aria-label="Schließen" className="p-1 hover:text-[color:var(--burgundy)]"><X className="h-4 w-4" /></button>
            </div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-3"><Phone className="h-4 w-4 text-[color:var(--burgundy)]" /><a href={`tel:${CONTACT.phoneRaw}`} className="link-underline">{CONTACT.phone}</a></li>
              <li className="flex items-center gap-3"><Mail className="h-4 w-4 text-[color:var(--burgundy)]" /><a href={`mailto:${CONTACT.email}`} className="link-underline">{CONTACT.email}</a></li>
              <li className="flex items-center gap-3"><Clock className="h-4 w-4 text-[color:var(--burgundy)]" /><span>{CONTACT.hoursShort}</span></li>
            </ul>
            <a
              href={`https://wa.me/${CONTACT.whatsapp.replace(/\+/g, "")}`}
              target="_blank"
              rel="noreferrer"
              data-testid="floating-whatsapp"
              className="mt-5 flex items-center justify-center gap-2 bg-[#25D366] text-white py-3 text-xs tracking-[0.14em] uppercase font-medium hover:bg-[#1ebe57] transition-colors"
            >
              <MessageCircle className="h-4 w-4" /> WhatsApp starten
            </a>
          </motion.div>
        )}
      </AnimatePresence>

      <button
        onClick={() => setOpen(v => !v)}
        data-testid="floating-contact-button"
        aria-label="Kontakt öffnen"
        className="group h-14 w-14 rounded-full bg-[color:var(--burgundy)] text-[color:var(--cream)] shadow-xl hover:bg-[color:var(--ink)] transition-all flex items-center justify-center"
      >
        {open ? <X className="h-5 w-5" /> : <Phone className="h-5 w-5 group-hover:rotate-[20deg] transition-transform" />}
      </button>
    </div>
  );
}
